import { LLMConversationContentSource } from '../../../types';
import { dateTimeDetailsFormatter, DetailList } from './ContentBase';
import ReactMarkdown from 'react-markdown';

interface ConversationsContentProps {
  insightDetailsContent: LLMConversationContentSource;
}

const ConversationsContent = ({
  insightDetailsContent,
}: ConversationsContentProps) => {
  return (
    <>
      <DetailList
        details={{
          Chatbot: insightDetailsContent?.chatbotName ?? '-',
          'Version ID': insightDetailsContent?.version_id ?? '-',
          'First message': dateTimeDetailsFormatter({
            date: insightDetailsContent?.created_at?.toString() ?? '-',
          }),
          'Last message':
            dateTimeDetailsFormatter({
              date: insightDetailsContent?.updated_at?.toString() ?? '-',
            }) ?? '-',
        }}
      />
      <hr />
      <ConversationHistory
        history={insightDetailsContent?.history ?? []}
        violations={insightDetailsContent?.violations ?? []}
      />
    </>
  );
};

const ConversationHistory = ({
  history,
  violations,
}: {
  history: LLMConversationContentSource['history'];
  violations: LLMConversationContentSource['violations'];
}) => {
  return (
    <>
      {history.map((turn, index) => (
        <div key={index}>
          <strong>{mapRoleToLabel(turn.role)}:</strong>{' '}
          <ReactMarkdown>{turn.content}</ReactMarkdown>
          {violations
            .filter((v) => v.turn_id === turn.turn_id)
            .map((v, vIndex) => (
              <>
                <div key={vIndex} style={{ color: 'red' }}>
                  <strong>Policy violation:</strong> {v.policy_name} (
                  {(v.confidence_score * 100).toFixed(2)}% confidence)
                </div>
                <div key={vIndex} style={{ color: 'red' }}>
                  <strong>Policy violation reason:</strong> {v.llm_reasoning}
                </div>
              </>
            ))}
          <hr />
        </div>
      ))}
    </>
  );
};

const mapRoleToLabel = (role: 'user' | 'assistant' | 'system') => {
  switch (role) {
    case 'user':
      return 'User';
    case 'assistant':
      return 'Chatbot';
    case 'system':
      return 'System';
    default:
      return role;
  }
};

export default ConversationsContent;
